import React from 'react';
import './Footer.css';
import { useLang } from '../contexts/LanguageContext';
import { useRegisterModal } from '../contexts/RegisterModalContext';

export default function Footer(){
  const { t } = useLang();
  const { openRegister } = useRegisterModal();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <div className="brand">{t('siteTitle')}</div>
          <div className="copyright">© {new Date().getFullYear()} {t('siteTitle')}. {t('allRights')}</div>
        </div>

        <nav className="footer-center">
          <a href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('terms'))}}>{t('terms')}</a>
          <a href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('privacy'))}}>{t('privacy')}</a>
          <a href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('support'))}}>{t('support')}</a>
          <a href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('contact'))}}>{t('contact')}</a>
        </nav>

        <div className="footer-right">
          <div className="small-stat">Live • <strong style={{color:'#ffd700'}}>4K</strong></div>
          <div className="socials">
            <a aria-label="instagram" href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('modalSocialMsg'))}}>IG</a>
            <a aria-label="twitter" href="#" onClick={(e)=>{e.preventDefault(); openRegister(t('modalSocialMsg'))}}>TW</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
